// TaskFlow · utilidades de interfaz: escape de HTML, íconos, fechas en español de Colombia, avisos y anuncios.

export const $ = (sel, raiz = document) => raiz.querySelector(sel);
export const $$ = (sel, raiz = document) => Array.from(raiz.querySelectorAll(sel));

/** Escapa texto para insertarlo en HTML. */
export function e(s) {
  return String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
}

export function uuid() {
  if (crypto.randomUUID) return crypto.randomUUID();
  const b = crypto.getRandomValues(new Uint8Array(16));
  b[6] = (b[6] & 0x0f) | 0x40; b[8] = (b[8] & 0x3f) | 0x80;
  const h = [...b].map((x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

// ---------- Íconos (Lucide, licencia ISC; trazo de 2px) ----------
const P = {
  check: '<path d="M20 6 9 17l-5-5"/>',
  alerta: '<circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/>',
  sol: '<circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41"/>',
  bandera: '<path d="M4 22V4a1 1 0 0 1 .4-.8A6 6 0 0 1 8 2c3 0 5 2 7.33 2q2 0 3.07-.8A1 1 0 0 1 20 4v10a1 1 0 0 1-.4.8A6 6 0 0 1 16 16c-3 0-5-2-8-2a6 6 0 0 0-4 1.53"/>',
  reloj: '<circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/>',
  repetir: '<path d="m17 2 4 4-4 4"/><path d="M3 11v-1a4 4 0 0 1 4-4h14"/><path d="m7 22-4-4 4-4"/><path d="M21 13v1a4 4 0 0 1-4 4H3"/>',
  reabrir: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/>',
  personas: '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>',
  sinred: '<path d="M12 20h.01M8.5 16.43a5 5 0 0 1 7 0M5 12.86a10 10 0 0 1 5.17-2.69M19 12.86a10 10 0 0 0-2-1.52M2 8.82a15 15 0 0 1 4.18-2.64M22 8.82a15 15 0 0 0-11.29-3.76M2 2l20 20"/>',
  sync: '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/><path d="M8 16H3v5"/>',
  mas: '<path d="M5 12h14M12 5v14"/>',
  ok: '<circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/>',
  whatsapp: '<path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/>',
  hoy: '<rect width="18" height="18" x="3" y="4" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/><path d="M8 14h.01M12 14h.01"/>',
  semana: '<path d="M8 2v4M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18M8 14h8M8 18h5"/>',
  calendario: '<path d="M8 2v4M16 2v4"/><rect width="18" height="18" x="3" y="4" rx="2"/><path d="M3 10h18"/>',
  bandeja: '<path d="M22 12h-6l-2 3h-4l-2-3H2"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
  pilas: '<path d="m12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z"/><path d="m22 17.65-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65"/><path d="m22 12.65-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65"/>',
  usuario: '<circle cx="12" cy="8" r="5"/><path d="M20 21a8 8 0 0 0-16 0"/>',
  buscar: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
  nota: '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4M10 9H8M16 13H8M16 17H8"/>',
  lista: '<path d="M11 6h10M11 12h10M11 18h10"/><path d="m3 6 1 1 2-2M3 12l1 1 2-2M3 18l1 1 2-2"/>',
  campana: '<path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9"/><path d="M10.3 21a1.94 1.94 0 0 0 3.4 0"/>',
  papelera: '<path d="M3 6h18M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2"/>',
  plantilla: '<rect width="18" height="7" x="3" y="3" rx="1"/><rect width="9" height="7" x="3" y="14" rx="1"/><rect width="5" height="7" x="16" y="14" rx="1"/>',
  ajustes: '<path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"/><circle cx="12" cy="12" r="3"/>',
  escudo: '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>',
  cerrar: '<path d="M18 6 6 18M6 6l12 12"/>',
  atras: '<path d="m15 18-6-6 6-6"/>',
  adelante: '<path d="m9 18 6-6-6-6"/>',
  mas_opciones: '<circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/>',
  arriba: '<path d="m18 15-6-6-6 6"/>',
  abajo: '<path d="m6 9 6 6 6-6"/>',
  asa: '<circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/>',
  clip: '<path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l8.57-8.57A4 4 0 1 1 18 8.84l-8.59 8.57a2 2 0 0 1-2.83-2.83l8.49-8.48"/>',
  descargar: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m7 10 5 5 5-5M12 15V3"/>',
  subir: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="m17 8-5-5-5 5M12 3v12"/>',
  compartir: '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><path d="m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98"/>',
  historial: '<path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5M12 7v5l4 2"/>',
  guardar: '<path d="M15.2 3a2 2 0 0 1 1.4.6l3.8 3.8a2 2 0 0 1 .6 1.4V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z"/><path d="M17 21v-7a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v7M7 3v4a1 1 0 0 0 1 1h7"/>',
  editar: '<path d="M12 20h9"/><path d="M16.38 3.62a1 1 0 0 1 3 3L7.37 18.64a2 2 0 0 1-.85.5l-2.87.84a.5.5 0 0 1-.62-.62l.84-2.87a2 2 0 0 1 .5-.85z"/>',
  foco: '<circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>',
  exportar: '<path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"/><path d="M14 2v4a2 2 0 0 0 2 2h4M12 18v-6M9 15l3 3 3-3"/>',
  salir: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9"/>',
  menu: '<path d="M4 12h16M4 6h16M4 18h16"/>',
  teclado: '<rect width="20" height="16" x="2" y="4" rx="2"/><path d="M6 8h.01M10 8h.01M14 8h.01M18 8h.01M8 12h.01M12 12h.01M16 12h.01M7 16h10"/>',
};
export function icono(n, clase = 'icono') {
  return `<svg class="${clase}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${P[n] || ''}</svg>`;
}

// ---------- Fechas (America/Bogota, es-CO) ----------
const ZONA = 'America/Bogota';
const DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
const DIAS_LARGOS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
export const MESES_LARGOS = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];

/** Fecha de hoy en Bogotá, AAAA-MM-DD. */
export function hoyISO() {
  return new Intl.DateTimeFormat('en-CA', { timeZone: ZONA, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
}
export function sumarDias(iso, n) {
  const [a, m, d] = iso.split('-').map(Number);
  const f = new Date(Date.UTC(a, m - 1, d + n));
  return f.toISOString().slice(0, 10);
}
function partes(iso) { const [a, m, d] = iso.split('-').map(Number); const f = new Date(Date.UTC(a, m - 1, d)); return { a, m, d, dow: f.getUTCDay() }; }
/** «lun 30 dic» */
export function fechaCorta(iso) { const p = partes(iso); return `${DIAS[p.dow]} ${p.d} ${MESES[p.m - 1]}`; }
/** «30 de diciembre de 2026» */
export function fechaLarga(iso) { const p = partes(iso); return `${p.d} de ${MESES_LARGOS[p.m - 1]} de ${p.a}`; }
/** «lunes 30 de diciembre» */
export function fechaDia(iso) { const p = partes(iso); return `${DIAS_LARGOS[p.dow]} ${p.d} de ${MESES_LARGOS[p.m - 1]}`; }
/** «3:00 p. m.» */
export function hora12(hhmm) {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  return `${h % 12 === 0 ? 12 : h % 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'a. m.' : 'p. m.'}`;
}
/** Fecha relativa cuando ayuda: «hoy», «mañana», «ayer», «vencida hace 3 días». */
export function fechaRelativa(iso) {
  const hoy = hoyISO();
  if (iso === hoy) return 'Hoy';
  if (iso === sumarDias(hoy, 1)) return 'Mañana';
  if (iso === sumarDias(hoy, -1)) return 'Ayer';
  return fechaCorta(iso);
}
export function diasEntre(desde, hasta) {
  return Math.round((Date.parse(hasta + 'T00:00:00Z') - Date.parse(desde + 'T00:00:00Z')) / 86400000);
}
/** «hace 2 horas», «hace 5 minutos», «ayer a las 3:00 p. m.» a partir de 'AAAA-MM-DD HH:MM:SS' (hora de Bogotá). */
export function haceTiempo(fechaHora) {
  if (!fechaHora) return '';
  const t = Date.parse(fechaHora.replace(' ', 'T') + '-05:00');
  const s = Math.round((Date.now() - t) / 1000);
  if (s < 45) return 'hace un momento';
  if (s < 3600) { const m = Math.round(s / 60); return `hace ${m} ${m === 1 ? 'minuto' : 'minutos'}`; }
  if (s < 86400) { const h = Math.round(s / 3600); return `hace ${h} ${h === 1 ? 'hora' : 'horas'}`; }
  const iso = fechaHora.slice(0, 10);
  const hh = hora12(fechaHora.slice(11, 16));
  if (iso === sumarDias(hoyISO(), -1)) return `ayer a las ${hh}`;
  return `${fechaCorta(iso)} · ${hh}`;
}

// ---------- Anuncios para lectores de pantalla ----------
export function anunciar(texto) {
  const r = document.getElementById('anuncios');
  if (!r || !texto) return;
  const p = document.createElement('p');
  p.textContent = texto;
  r.appendChild(p);
  setTimeout(() => p.remove(), 8000);
}
export function alertar(texto) {
  const r = document.getElementById('alertas');
  if (r) { r.textContent = ''; setTimeout(() => { r.textContent = texto; }, 50); }
}

// ---------- Aviso con Deshacer (6 s; se pausa con foco o puntero) ----------
let avisoActual = null;
export function aviso(texto, { deshacer = null, duracion = 6000 } = {}) {
  const zona = document.getElementById('zona-avisos');
  if (!zona) return;
  if (avisoActual) avisoActual.cerrar();
  const div = document.createElement('div');
  div.className = 'tf-aviso tf-entra';
  div.setAttribute('role', 'status');
  div.innerHTML = `<span>${e(texto)}</span>${deshacer ? '<button class="tf-boton tf-boton--fantasma" type="button">Deshacer</button>' : ''}`;
  zona.appendChild(div);
  let restante = duracion, inicio = Date.now(), timer = null;
  const cerrar = () => { clearTimeout(timer); div.remove(); if (avisoActual?.div === div) avisoActual = null; };
  const correr = () => { inicio = Date.now(); timer = setTimeout(cerrar, restante); };
  const pausar = () => { clearTimeout(timer); restante -= Date.now() - inicio; };
  div.addEventListener('mouseenter', pausar); div.addEventListener('mouseleave', correr);
  div.addEventListener('focusin', pausar); div.addEventListener('focusout', correr);
  if (deshacer) div.querySelector('button').addEventListener('click', () => { cerrar(); deshacer(); });
  avisoActual = { div, cerrar, deshacer };
  correr();
}
/** Ctrl+Z deshace el último aviso con Deshacer. */
export function deshacerUltimo() {
  if (avisoActual?.deshacer) { const f = avisoActual.deshacer; avisoActual.cerrar(); f(); return true; }
  return false;
}

// ---------- Diálogos accesibles (<dialog> nativo: atrapa el foco y cierra con Esc) ----------
export function dialogo(html, { alCerrar } = {}) {
  const d = document.createElement('dialog');
  d.innerHTML = html;
  document.body.appendChild(d);
  const previo = document.activeElement;
  d.addEventListener('close', () => { d.remove(); if (previo && previo.focus) previo.focus(); if (alCerrar) alCerrar(d.returnValue); });
  d.addEventListener('click', (ev) => { if (ev.target === d) d.close('cancelar'); });
  d.showModal();
  return d;
}
/** Confirmación para acciones destructivas. Devuelve una promesa con true/false. */
export function confirmar({ titulo, texto, boton = 'Eliminar', peligro = true }) {
  return new Promise((res) => {
    const d = dialogo(`<form method="dialog" class="cuerpo-dialogo" aria-labelledby="dlg-t">
      <h2 id="dlg-t">${e(titulo)}</h2><p>${e(texto)}</p>
      <div class="acciones"><button class="tf-boton" value="no" type="submit" autofocus>Cancelar</button>
      <button class="tf-boton ${peligro ? 'tf-boton--peligro' : 'tf-boton--principal'}" value="si" type="submit">${e(boton)}</button></div></form>`,
    { alCerrar: (v) => res(v === 'si') });
    d.querySelector('[autofocus]')?.focus();
  });
}

// ---------- Menú contextual accesible ----------
export function menu(boton, opciones) {
  document.querySelectorAll('.menu').forEach((m) => m.remove());
  const m = document.createElement('div');
  m.className = 'menu'; m.setAttribute('role', 'menu');
  m.innerHTML = opciones.map((o, i) => o === '-' ? '<hr>' : `<button type="button" role="menuitem" data-i="${i}" ${o.deshabilitado ? 'aria-disabled="true"' : ''} ${o.ayuda ? `title="${e(o.ayuda)}"` : ''}>${o.icono ? icono(o.icono) : ''}<span>${e(o.texto)}</span></button>`).join('');
  document.body.appendChild(m);
  const r = boton.getBoundingClientRect();
  const ancho = m.offsetWidth, alto = m.offsetHeight;
  m.style.left = Math.max(8, Math.min(r.right - ancho, window.innerWidth - ancho - 8)) + 'px';
  m.style.top = (r.bottom + alto + 8 > window.innerHeight ? Math.max(8, r.top - alto - 4) : r.bottom + 4) + 'px';
  boton.setAttribute('aria-expanded', 'true');
  const items = $$('[role="menuitem"]', m);
  const cerrar = (volver = true) => { m.remove(); boton.setAttribute('aria-expanded', 'false'); document.removeEventListener('pointerdown', fuera, true); if (volver) boton.focus(); };
  const fuera = (ev) => { if (!m.contains(ev.target)) cerrar(false); };
  setTimeout(() => document.addEventListener('pointerdown', fuera, true));
  m.addEventListener('keydown', (ev) => {
    const i = items.indexOf(document.activeElement);
    if (ev.key === 'ArrowDown') { ev.preventDefault(); items[(i + 1) % items.length].focus(); }
    else if (ev.key === 'ArrowUp') { ev.preventDefault(); items[(i - 1 + items.length) % items.length].focus(); }
    else if (ev.key === 'Home') { ev.preventDefault(); items[0].focus(); }
    else if (ev.key === 'End') { ev.preventDefault(); items[items.length - 1].focus(); }
    else if (ev.key === 'Escape' || ev.key === 'Tab') { ev.preventDefault(); cerrar(); }
  });
  m.addEventListener('click', (ev) => {
    const b = ev.target.closest('[role="menuitem"]');
    if (!b) return;
    const o = opciones[Number(b.dataset.i)];
    if (o.deshabilitado) { aviso(o.ayuda || 'Esta acción no está disponible.'); return; }
    cerrar(); o.accion();
  });
  items[0]?.focus();
}

export function bytes(n) {
  if (n < 1024) return `${n} B`;
  if (n < 1048576) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1073741824) return `${(n / 1048576).toFixed(1).replace('.', ',')} MB`;
  return `${(n / 1073741824).toFixed(1).replace('.', ',')} GB`;
}
export function plural(n, uno, varios) { return `${n} ${n === 1 ? uno : varios}`; }
